import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appInsertionHost]'
})
export class InsertionHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
